export default __webpack_public_path__ + "static/media/img_url_response-colorBkg.f7fde6c1.png";